import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { checkAccessToken } from '@/utils/handle-authentication';
import { getListProject, TGetListProjectResponse } from '@/services/api/employee';
import { getListProjectAction } from '@/redux/actions/employee';
import { handleAPIError } from '@/utils/handle-api-error';

// FUNCTION
export function* getListProjectSaga(action: ActionType<typeof getListProjectAction.request>): Generator {
  const { companyId, employeeId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(getListProject, companyId, employeeId);
    const getListProjectResponse: TGetListProjectResponse = response as TGetListProjectResponse;
    yield put(getListProjectAction.success(getListProjectResponse));
    successCallback?.(getListProjectResponse);
  } catch (err) {
    handleAPIError(err, 'Error.listProjectByEmployeeError');
    yield put(getListProjectAction.failure(err));
    failedCallback?.(err);
  }
}
